import(/* webpackMode: "eager" */ "/Users/theopak/git/theopak.com/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/theopak/git/theopak.com/components/Home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WindowContextProvider"] */ "/Users/theopak/git/theopak.com/components/WindowContext.tsx");
;
import(/* webpackMode: "eager" */ "/Users/theopak/git/theopak.com/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./TX-02-Variable.woff2\",\"variable\":\"--font-BerkeleyMono\"}],\"variableName\":\"BerkeleyMono\"}");
